const URL = {
  GET_SHOP: 'Shop/GetShop',
  EDIT_SHOP: 'Shop/EditShop',
  PATCH_SHOP: 'Shop/PatchShop',
}

export default URL
